import React, { useCallback } from "react"
import { useTranslation } from "react-i18next"
import * as Components from "../../components/components"
import { getUmsatzsteuerCodesOptions } from "../../constants"
import { EventBus } from "../../eventbus"
import { SteuerDetails } from "../../models/rechnung/rechnungsebene/steuerdetails"

export type SteuerDetailsData = Omit<SteuerDetails, "notEmpty">

interface SteuerDetailProps {
    index: number
    steuerDetails: SteuerDetailsData
}

export default function SteuerDetail({
    index,
    steuerDetails: { gesamtsummeNetto, umsatzsteuerbetrag, umsatzsteuerCode, umsatzsteuersatz, befreiungsgrund, befreiungsgrundCode },
}: SteuerDetailProps) {
    const { t } = useTranslation()
    const umsatzsteuerCodesOptions = getUmsatzsteuerCodesOptions()
    const onChange = useCallback<(element: string) => (value: any) => void>(
        (element: string) => (value: any) => {
            EventBus.instance.emit("changeProperty", `steuerDetails.${index}.${element}`, value)
        },
        [index],
    )

    return (
        <div className="steuerDetail">
            <Components.FormGroup label={t("rechnung.steuerDetails.gesamtsummeNetto.label")}>
                <Components.NumberEdit value={gesamtsummeNetto} readonly />
            </Components.FormGroup>

            <Components.FormGroup label={t("rechnung.steuerDetails.umsatzsteuerbetrag.label")}>
                <Components.NumberEdit value={umsatzsteuerbetrag} readonly />
            </Components.FormGroup>

            <Components.FormGroup label={t("rechnung.steuerDetails.umsatzsteuerCode.label")}>
                <Components.MultiSelect
                    placeholder={t("rechnung.steuerDetails.umsatzsteuerCode.placeholder")}
                    value={umsatzsteuerCodesOptions.find((o) => o.value === umsatzsteuerCode)}
                    options={umsatzsteuerCodesOptions}
                    readonly
                />
            </Components.FormGroup>

            <Components.FormGroup label={t("rechnung.steuerDetails.umsatzsteuersatz.label")}>
                <Components.NumberEdit value={umsatzsteuersatz} readonly suffix=" %" />
            </Components.FormGroup>

            <Components.FormGroup label={t("rechnung.steuerDetails.befreiungsgrund.label")}>
                <Components.TextEdit
                    placeholder={t("rechnung.steuerDetails.befreiungsgrund.placeholder")}
                    onChange={onChange("befreiungsgrund")}
                    value={befreiungsgrund}
                />
            </Components.FormGroup>

            <Components.FormGroup label={t("rechnung.steuerDetails.befreiungsgrundCode.label")}>
                <Components.TextEdit
                    placeholder={t("rechnung.steuerDetails.befreiungsgrundCode.placeholder")}
                    onChange={onChange("befreiungsgrundCode")}
                    value={befreiungsgrundCode}
                />
            </Components.FormGroup>
        </div>
    )
}
